import i18n from "@/i18n";
import ReactDOMServer from "react-dom/server";
import {
  LETTER_HEADER_VARIABLE,
  LetterHeaderContent,
  PAGECONFIG_TO_PIXEL_RATIO,
} from "./BFDocument.service";
import { DOCUMENT_FONT_FAMILY } from "./BFDocumentView";
import BFLetterVariable from "./BFLetterVariable";

interface BFLetterFooterProps {
  content: LetterHeaderContent;
  ignoreMargins?: boolean;
}
export const getLetterFooter = (
  content: LetterHeaderContent,
  ignoreMargins = true
) =>
  ReactDOMServer.renderToString(
    <BFLetterFooter content={content} ignoreMargins={ignoreMargins} />
  );
const BFLetterFooter = (props: BFLetterFooterProps) => {
  const variables = LETTER_HEADER_VARIABLE();

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        // marginTop: 20 * PAGECONFIG_TO_PIXEL_RATIO,
        marginLeft: props.ignoreMargins ? 0 : 20 * PAGECONFIG_TO_PIXEL_RATIO,
        marginRight: props.ignoreMargins ? 0 : 20 * PAGECONFIG_TO_PIXEL_RATIO,
        marginBottom: props.ignoreMargins ? 0 : 5 * PAGECONFIG_TO_PIXEL_RATIO,
      }}
    >
      <hr
        style={{
          padding: 0,
          marginTop: props.ignoreMargins
            ? undefined
            : 5 * PAGECONFIG_TO_PIXEL_RATIO,
          marginBottom: props.ignoreMargins
            ? undefined
            : 5 * PAGECONFIG_TO_PIXEL_RATIO,
        }}
      />

      {/* <div
        style={{
          display: "flex",
          fontSize: 10,
          paddingBottom: 10,
          fontFamily: DOCUMENT_FONT_FAMILY,
          lineHeight: "12px",
          color: "#000",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {
          i18n.t("BFLetterFooter.page", "Seite") // "Seite"
        }{" "}
        <span className={`pageNumber`}>1</span>/
        <span className={`totalPages`}>1</span>
      </div> */}
      <div
        style={{
          display: "flex",
          gap: 40,
          justifyContent: "space-between",
        }}
      >
        <div
          className={`letter-footer__sender`}
          style={{
            // position: "absolute",
            // top: 24 * PAGECONFIG_TO_PIXEL_RATIO,
            // left: 2 * PAGECONFIG_TO_PIXEL_RATIO,
            // height: 5.5 * PAGECONFIG_TO_PIXEL_RATIO,
            //   width: 85 * PAGECONFIG_TO_PIXEL_RATIO,
            fontFamily: DOCUMENT_FONT_FAMILY,
            fontSize: 10,
            lineHeight: "12px",
            color: "#000",
          }}
        >
          <BFLetterVariable
            variables={variables}
            variableId="senderName"
            value={props.content.sender.name}
          />
          <br />
          <BFLetterVariable
            variables={variables}
            variableId="senderStreet"
            value={props.content.sender.street}
          />
          <br />
          <BFLetterVariable
            variables={variables}
            variableId="senderZip"
            value={props.content.sender.zip}
          />{" "}
          <BFLetterVariable
            variables={variables}
            variableId="senderCity"
            value={props.content.sender.city}
          />
        </div>
        <div
          style={{
            fontSize: 10,
            fontFamily: DOCUMENT_FONT_FAMILY,
            lineHeight: "12px",
            color: "#000",
            textAlign: "left",
          }}
        >
          <span style={{ fontWeight: "bold", fontSize: 9 }}>
            {i18n.t("BFLetterFooter.contact", "Kontakt")}:
          </span>{" "}
          <br />
          {i18n.t("BFLetterFooter.tel", "Tel.")}:{" "}
          <BFLetterVariable
            variables={variables}
            variableId="senderPhone"
            value={props.content.sender.phone}
          />
          <br />
          {i18n.t("BFLetterFooter.fax", "Fax.")}:{" "}
          <BFLetterVariable
            variables={variables}
            variableId="senderFax"
            value={props.content.sender.fax}
          />
          <br />
          {i18n.t("BFLetterFooter.mail", "E-Mail")}:{" "}
          <BFLetterVariable
            variables={variables}
            variableId="senderMail"
            value={props.content.sender.mail}
          />
          <br />
          <BFLetterVariable
            variables={variables}
            variableId="senderWebsite"
            value={props.content.sender.website}
          />
        </div>
        <div
          style={{
            fontSize: 10,
            fontFamily: DOCUMENT_FONT_FAMILY,
            lineHeight: "12px",
            color: "#000",
            textAlign: "left",
          }}
        >
          <span style={{ fontWeight: "bold", fontSize: 9 }}>
            {i18n.t("BFLetterFooter.bankAccount", "Bankverbindung")}:
          </span>{" "}
          <br />
          IBAN:{" "}
          <BFLetterVariable
            variables={variables}
            variableId="iban"
            value={props.content.iban}
          />
          <br />
          BIC:{" "}
          <BFLetterVariable
            variables={variables}
            variableId="bic"
            value={props.content.bic}
          />
        </div>
      </div>
    </div>
  );
};

export default BFLetterFooter;
